import React, { useEffect, useState } from 'react';
import BaseModal from '../modals/BaseModal';

const getDefaultNotes = prospect => (
  [
    'Opprettet fra LinkedIn Outreach.',
    `LinkedIn: ${prospect?.linkedin_url || '-'}`,
    `Prospect-notat: ${prospect?.notes || '-'}`
  ].join('\n')
);

const CreateOpportunityModal = ({
  isOpen,
  prospect,
  stageId,
  onClose,
  onSubmit,
  isSubmitting
}) => {
  const [title, setTitle] = useState('');
  const [value, setValue] = useState(0);
  const [probability, setProbability] = useState(10);
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (!prospect) return;

    setTitle(`LinkedIn-mulighet: ${prospect.full_name || ''}`.trim());
    setValue(0);
    setProbability(10);
    setNotes(getDefaultNotes(prospect));
  }, [prospect]);

  if (!prospect) return null;

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Opprett salgsmulighet"
      size="lg"
    >
      <form
        className="space-y-5"
        onSubmit={event => {
          event.preventDefault();
          onSubmit({ title, value, probability, notes, stage_id: stageId });
        }}
      >
        <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-sm text-slate-600 space-y-1">
          <p><strong>Prospect:</strong> {prospect.full_name}</p>
          <p><strong>Tittel:</strong> {prospect.title || '-'}</p>
          <p><strong>Selskap:</strong> {prospect.company_name || '-'}</p>
          <p className="break-all"><strong>LinkedIn:</strong> {prospect.linkedin_url || '-'}</p>
          <p><strong>Kilde:</strong> LinkedIn Outreach</p>
        </div>

        <div>
          <label className="block text-xs font-bold uppercase tracking-wide text-slate-500 mb-2">
            Deal-tittel
          </label>
          <input
            value={title}
            onChange={event => setTitle(event.target.value)}
            className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-blue-500"
            required
          />
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label className="block text-xs font-bold uppercase tracking-wide text-slate-500 mb-2">
              Verdi
            </label>
            <input
              type="number"
              min="0"
              value={value}
              onChange={event => setValue(event.target.value)}
              className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-blue-500"
            />
          </div>

          <div>
            <label className="block text-xs font-bold uppercase tracking-wide text-slate-500 mb-2">
              Sannsynlighet (%)
            </label>
            <input
              type="number"
              min="0"
              max="100"
              value={probability}
              onChange={event => setProbability(event.target.value)}
              className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-blue-500"
            />
          </div>
        </div>

        <div>
          <label className="block text-xs font-bold uppercase tracking-wide text-slate-500 mb-2">
            Notat / kommentar
          </label>
          <textarea
            value={notes}
            onChange={event => setNotes(event.target.value)}
            rows={5}
            className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-blue-500"
          />
        </div>

        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            disabled={isSubmitting}
            className="flex-1 rounded-xl bg-slate-100 py-3 text-sm font-bold text-slate-600 hover:bg-slate-200 disabled:opacity-50"
          >
            Avbryt
          </button>
          <button
            type="submit"
            disabled={isSubmitting}
            className="flex-[2] rounded-xl bg-slate-900 py-3 text-sm font-bold text-white hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isSubmitting ? 'Oppretter...' : 'Opprett salgsmulighet'}
          </button>
        </div>
      </form>
    </BaseModal>
  );
};

export default CreateOpportunityModal;